import React from "react";
import { Helmet } from "react-helmet";

function Seo(props){
  const { seoContent } = props;

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{seoContent.seo_title}</title>
      <meta name="Author" content="wasth.com" />
      <meta content="INDEX,FOLLOW" name="robots" />

      <meta property="og:url" content={window.location.href}></meta>
      <meta property="og:locale" content="vi_VN"></meta>
      <meta property="og:title" content={seoContent.seo_title} />
      <meta property="og:site_name" content={seoContent.name} />
      <meta property="og:description" content={seoContent.seo_description}></meta>

      <meta property="article:publisher" content={seoContent.seo_description}></meta>

      <meta property="fb:admins" content="https://www.facebook.com/Wasth-developer-web-and-app-100204468473353" />

      <meta itemprop="name" content={seoContent.seo_title} />
      <meta itemprop="description" content={seoContent.seo_description} />
    </Helmet>
  );
}

export default Seo;